import ArmsCrossedModel from "@/assets/pose-assets/example-arms-crossed/model.glb";
import ArmsCrossedOpenPose from "@/assets/pose-assets/example-arms-crossed/open-pose.png";
import ArmsCrossedOpenPoseThumbnail from "@/assets/pose-assets/example-arms-crossed/open-pose-thumbnail.png";
import ArmsCrossedShowcaseImage from "@/assets/pose-assets/example-arms-crossed/show-case-image.png";
import FightStanceModel from "@/assets/pose-assets/example-fight-stance/model.glb";
import FightStanceOpenPose from "@/assets/pose-assets/example-fight-stance/open-pose.png";
import FightStanceOpenPoseThumbnail from "@/assets/pose-assets/example-fight-stance/open-pose-thumbnail.png";
import FightStanceShowcaseImage from "@/assets/pose-assets/example-fight-stance/show-case-image.png";
import HandOnHipOtherPointingModel from "@/assets/pose-assets/example-hand-on-hip-other-pointing/model.glb";
import HandOnHipOtherPointingOpenPose from "@/assets/pose-assets/example-hand-on-hip-other-pointing/open-pose.png";
import HandOnHipOtherPointingOpenPoseThumbnail from "@/assets/pose-assets/example-hand-on-hip-other-pointing/open-pose-thumbnail.png";
import HandOnHipOtherPointingShowcaseImage from "@/assets/pose-assets/example-hand-on-hip-other-pointing/show-case-image.png";
import HandsAtBodyHeightModel from "@/assets/pose-assets/example-hands-at-body-height/model.glb";
import HandsAtBodyHeightOpenPose from "@/assets/pose-assets/example-hands-at-body-height/open-pose.png";
import HandsAtBodyHeightOpenPoseThumbnail from "@/assets/pose-assets/example-hands-at-body-height/open-pose-thumbnail.png";
import HandsAtBodyHeightShowcaseImage from "@/assets/pose-assets/example-hands-at-body-height/show-case-image.png";
import HandsDownModel from "@/assets/pose-assets/example-hands-down/model.glb";
import HandsDownOpenPose from "@/assets/pose-assets/example-hands-down/open-pose.png";
import HandsDownOpenPoseThumbnail from "@/assets/pose-assets/example-hands-down/open-pose-thumbnail.png";
import HandsDownShowcaseImage from "@/assets/pose-assets/example-hands-down/show-case-image.png";
import HandsOnFaceOtherOnWaistModel from "@/assets/pose-assets/example-hands-on-face-other-on-waist/model.glb";
import HandsOnFaceOtherOnWaistOpenPose from "@/assets/pose-assets/example-hands-on-face-other-on-waist/open-pose.png";
import HandsOnFaceOtherOnWaistOpenPoseThumbnail from "@/assets/pose-assets/example-hands-on-face-other-on-waist/open-pose-thumbnail.png";
import HandsOnFaceOtherOnWaistShowcaseImage from "@/assets/pose-assets/example-hands-on-face-other-on-waist/show-case-image.png";
import HandsOnWaistHoldingObjectModel from "@/assets/pose-assets/example-hands-on-waist-holding-object/model.glb";
import HandsOnWaistHoldingObjectOpenPose from "@/assets/pose-assets/example-hands-on-waist-holding-object/open-pose.png";
import HandsOnWaistHoldingObjectOpenPoseThumbnail from "@/assets/pose-assets/example-hands-on-waist-holding-object/open-pose-thumbnail.png";
import HandsOnWaistHoldingObjectShowcaseImage from "@/assets/pose-assets/example-hands-on-waist-holding-object/show-case-image.png";
import HandsRaisedHighModel from "@/assets/pose-assets/example-hands-raised-high/model.glb";
import HandsRaisedHighOpenPose from "@/assets/pose-assets/example-hands-raised-high/open-pose.png";
import HandsRaisedHighOpenPoseThumbnail from "@/assets/pose-assets/example-hands-raised-high/open-pose-thumbnail.png";
import HandsRaisedHighShowcaseImage from "@/assets/pose-assets/example-hands-raised-high/show-case-image.png";
import HandsRaisedPointingModel from "@/assets/pose-assets/example-hands-raised-pointing/model.glb";
import HandsRaisedPointingOpenPose from "@/assets/pose-assets/example-hands-raised-pointing/open-pose.png";
import HandsRaisedPointingOpenPoseThumbnail from "@/assets/pose-assets/example-hands-raised-pointing/open-pose-thumbnail.png";
import HandsRaisedPointingShowcaseImage from "@/assets/pose-assets/example-hands-raised-pointing/show-case-image.png";
import OneHandRaisedOneOnHipModel from "@/assets/pose-assets/example-one-hand-raised-one-on-hip/model.glb";
import OneHandRaisedOneOnHipOpenPose from "@/assets/pose-assets/example-one-hand-raised-one-on-hip/open-pose.png";
import OneHandRaisedOneOnHipOpenPoseThumbnail from "@/assets/pose-assets/example-one-hand-raised-one-on-hip/open-pose-thumbnail.png";
import OneHandRaisedOneOnHipShowcaseImage from "@/assets/pose-assets/example-one-hand-raised-one-on-hip/show-case-image.png";

import { PoseViewData } from "../../../../types";

interface BasePose {
  id: string;
  name: string;
  poseData: PoseViewData;
}

enum PoseAssetId {
  ARMS_CROSSED = "example-arms-crossed",
  FIGHT_STANCE = "example-fight-stance",
  HAND_ON_HIP_OTHER_POINTING = "example-hand-on-hip-other-pointing",
  HANDS_AT_BODY_HEIGHT = "example-hands-at-body-height",
  HANDS_DOWN = "example-hands-down",
  HANDS_ON_FACE_OTHER_ON_WAIST = "example-hands-on-face-other-on-waist",
  HANDS_ON_WAIST_HOLDING_OBJECT = "example-hands-on-waist-holding-object",
  HANDS_RAISED_HIGH = "example-hands-raised-high",
  HANDS_RAISED_POINTING = "example-hands-raised-pointing",
  ONE_HAND_RAISED_ONE_ON_HIP = "example-one-hand-raised-one-on-hip",
}

const poseAssets = {
  [PoseAssetId.ARMS_CROSSED]: {
    url: ArmsCrossedOpenPose,
    modelUrl: ArmsCrossedModel,
    thumbnailUrl: ArmsCrossedOpenPoseThumbnail,
    showcaseImageUrl: ArmsCrossedShowcaseImage,
  },
  [PoseAssetId.FIGHT_STANCE]: {
    url: FightStanceOpenPose,
    modelUrl: FightStanceModel,
    thumbnailUrl: FightStanceOpenPoseThumbnail,
    showcaseImageUrl: FightStanceShowcaseImage,
  },
  [PoseAssetId.HAND_ON_HIP_OTHER_POINTING]: {
    url: HandOnHipOtherPointingOpenPose,
    modelUrl: HandOnHipOtherPointingModel,
    thumbnailUrl: HandOnHipOtherPointingOpenPoseThumbnail,
    showcaseImageUrl: HandOnHipOtherPointingShowcaseImage,
  },
  [PoseAssetId.HANDS_AT_BODY_HEIGHT]: {
    url: HandsAtBodyHeightOpenPose,
    modelUrl: HandsAtBodyHeightModel,
    thumbnailUrl: HandsAtBodyHeightOpenPoseThumbnail,
    showcaseImageUrl: HandsAtBodyHeightShowcaseImage,
  },
  [PoseAssetId.HANDS_DOWN]: {
    url: HandsDownOpenPose,
    modelUrl: HandsDownModel,
    thumbnailUrl: HandsDownOpenPoseThumbnail,
    showcaseImageUrl: HandsDownShowcaseImage,
  },
  [PoseAssetId.HANDS_ON_FACE_OTHER_ON_WAIST]: {
    url: HandsOnFaceOtherOnWaistOpenPose,
    modelUrl: HandsOnFaceOtherOnWaistModel,
    thumbnailUrl: HandsOnFaceOtherOnWaistOpenPoseThumbnail,
    showcaseImageUrl: HandsOnFaceOtherOnWaistShowcaseImage,
  },
  [PoseAssetId.HANDS_ON_WAIST_HOLDING_OBJECT]: {
    url: HandsOnWaistHoldingObjectOpenPose,
    modelUrl: HandsOnWaistHoldingObjectModel,
    thumbnailUrl: HandsOnWaistHoldingObjectOpenPoseThumbnail,
    showcaseImageUrl: HandsOnWaistHoldingObjectShowcaseImage,
  },
  [PoseAssetId.HANDS_RAISED_HIGH]: {
    url: HandsRaisedHighOpenPose,
    modelUrl: HandsRaisedHighModel,
    thumbnailUrl: HandsRaisedHighOpenPoseThumbnail,
    showcaseImageUrl: HandsRaisedHighShowcaseImage,
  },
  [PoseAssetId.HANDS_RAISED_POINTING]: {
    url: HandsRaisedPointingOpenPose,
    modelUrl: HandsRaisedPointingModel,
    thumbnailUrl: HandsRaisedPointingOpenPoseThumbnail,
    showcaseImageUrl: HandsRaisedPointingShowcaseImage,
  },
  [PoseAssetId.ONE_HAND_RAISED_ONE_ON_HIP]: {
    url: OneHandRaisedOneOnHipOpenPose,
    modelUrl: OneHandRaisedOneOnHipModel,
    thumbnailUrl: OneHandRaisedOneOnHipOpenPoseThumbnail,
    showcaseImageUrl: OneHandRaisedOneOnHipShowcaseImage,
  },
};

const poses: BasePose[] = [
  {
    id: PoseAssetId.FIGHT_STANCE,
    name: "Fight Stance.png",
    poseData: {
      camera: {
        position: [0.4617, 1.6628, 2.3320000000000003],
      },
      orbitControl: {
        target: [0, 0.89, 0],
      },
    },
  },
  {
    id: PoseAssetId.HANDS_AT_BODY_HEIGHT,
    name: "Hands at Body Height.png",
    poseData: {
      camera: {
        position: [0, 0.89, 2.5],
      },
      orbitControl: {
        target: [0, 0.89, 0],
      },
    },
  },
  {
    id: PoseAssetId.HANDS_ON_WAIST_HOLDING_OBJECT,
    name: "Hand on Waist, Holding Object.png",
    poseData: {
      camera: {
        position: [0.2184, 1.2884, 2.458],
      },
      orbitControl: {
        target: [0, 0.89, 0],
      },
    },
  },
  {
    id: PoseAssetId.HANDS_RAISED_HIGH,
    name: "Hands Raised High.png",
    poseData: {
      camera: {
        position: [0.20520000000000002, 1.7235, 1.7982],
      },
      orbitControl: {
        target: [0, 1.4000000000000001, 0],
      },
    },
  },
  {
    id: PoseAssetId.ARMS_CROSSED,
    name: "Arms Crossed.png",
    poseData: {
      camera: {
        position: [0, 1.2, 1.6700000000000002],
      },
      orbitControl: {
        target: [0, 1.2, 0],
      },
    },
  },
  {
    id: PoseAssetId.HANDS_ON_FACE_OTHER_ON_WAIST,
    name: "Hand on Face, Other on Waist.png",
    poseData: {
      camera: {
        position: [0, 1.2, 1.6700000000000002],
      },
      orbitControl: {
        target: [0, 1.2, 0],
      },
    },
  },
  {
    id: PoseAssetId.HAND_ON_HIP_OTHER_POINTING,
    name: "Hand on Hip, Other Pointing.png",
    poseData: {
      camera: {
        position: [0, 0.89, 2.5],
      },
      orbitControl: {
        target: [0, 0.89, 0],
      },
    },
  },
  {
    id: PoseAssetId.ONE_HAND_RAISED_ONE_ON_HIP,
    name: "One Hand Raised, One on Hip.png",
    poseData: {
      camera: {
        position: [0, 1.2, 1.7459],
      },
      orbitControl: {
        target: [0, 1.2, 0],
      },
    },
  },
  {
    id: PoseAssetId.HANDS_RAISED_POINTING,
    name: "Hands Raised, Pointing.png",
    poseData: {
      camera: {
        position: [0.18380000000000002, 1.1622000000000001, 2.476],
      },
      orbitControl: {
        target: [0, 0.89, 0],
      },
    },
  },
  {
    id: PoseAssetId.HANDS_DOWN,
    name: "Hands Down.png",
    poseData: {
      camera: {
        position: [-0.1482, 1.2431, 1.6636000000000002],
      },
      orbitControl: {
        target: [0, 1.2, 0],
      },
    },
  },
];

export interface Pose extends BasePose {
  url: string;
  modelUrl: string;
  thumbnailUrl: string;
  showcaseImageUrl: string;
}

export const examplePoses = poses.map(
  (pose): Pose => ({
    ...pose,
    ...poseAssets[pose.id as keyof typeof poseAssets],
  }),
);
